import type { LanguageCode } from "../languages/language-codes";
import { Button } from "@acdc2/ui/components/button";
import { mdiTranslate } from "@mdi/js";
import { Icon } from "@mdi/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LanguageCommand } from "../languages/LanguageCommand";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@acdc2/ui/components/popover";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@acdc2/ui/components/tooltip";

type Props = {
  value?: LanguageCode;
  onValueChange: (value: LanguageCode) => void;
  disabled?: boolean;
};

export function MetadataTitleLanguageCombobox({
  value,
  onValueChange,
  disabled,
}: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleSelect = (newLanguage: LanguageCode) => {
    onValueChange(newLanguage);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <Button
                type="button"
                size="icon"
                variant="outline"
                role="combobox"
                aria-expanded={open}
                disabled={disabled}
              >
                {value ? (
                  <div className="py-1 font-bold">{value.toUpperCase()}</div>
                ) : (
                  <Icon path={mdiTranslate} size="1.25rem" />
                )}
              </Button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent>
            {t("MetadataTitleLanguageCombobox.tooltip")}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <PopoverContent className="p-0 mx-2">
        <LanguageCommand value={value} onSelect={handleSelect} />
      </PopoverContent>
    </Popover>
  );
}
